import Box from '@redbubble/design-system/src/Box';
import { Ellipse } from '../Colon/Ellipse/Ellipse';
import styles from './Colon.module.scss';

export const Colon: React.FC = () => {
  return (
    <Box className={styles.colon}>
      <Ellipse />
      <Ellipse />
    </Box>
  );
};
